export const DATE_FORMAT = "MM/DD";

export const SHOP_HOURS = "SHOP";
export const LUNCH_HOURS = "LUNCH";
export const TRAINING_HOURS = "TRAINING";
export const MAX_NOTE_LENGTH = 255;

export const TIME_TYPE_MAPPING = {
  JURY: "JURY DUTY",
  BER: "BEREAVEMENT",
};

export const REVERSE_TIME_TYPE_MAPPING = {
  BEREAVEMENT: "BER",
  "JURY DUTY": "JURY",
};
